<div class="row">
	<ng-container
		*ngTemplateOutlet="contentTpl; context: { items: items }"
	></ng-container>
	<app-atom-intersection-observer (onIntersection)="walk()">
	</app-atom-intersection-observer>
</div>
